import {
  Container,
  Description,
  Logo,
  RedirectSection,
  StyledLink,
  TextSection,
  Title,
} from './NotFound.styles'

import styled from 'styled-components'
import { he } from '../../locales/he'
import { PocTaboolaPageType, PocTaboolaSuffixId, Taboola } from '../Taboola'
import { mediaCdn } from '../Player/Helpers'
import { useTaboola } from '../Taboola/useTaboola'
import { useEffect } from 'react'

const TaboolaWrap = styled.div`
  max-width: 1290px;
  margin: 150px auto auto;
`

export const NotFound = () => {
  const { setTaboolaPageType } = useTaboola()

  useEffect(() => {
    setTaboolaPageType({ other: 'auto' })
  }, [setTaboolaPageType])

  return (
    <Container>
      <RedirectSection>
        <Logo
          loading='lazy'
          mobile={`${mediaCdn}c_scale,q_auto,w_67/v1750602416/LOGO2025_euffps.webp`}
          desktop={`${mediaCdn}q_auto/v1750602416/LOGO2025_euffps.webp`}
        />
        <TextSection>
          <Title>{he.notFoundTitle}</Title>
          <Description>{he.notFoundDescription}</Description>
          <StyledLink href='/'>{he.notFoundButton}</StyledLink>
        </TextSection>
      </RedirectSection>
      <TaboolaWrap>
        <Taboola
          pageType={PocTaboolaPageType.notFound}
          suffixId={PocTaboolaSuffixId.pageFooter}
        />
      </TaboolaWrap>
    </Container>
  )
}
